import store from "../store";

export const varietyFormatter = (code) => {
  const res = Array.isArray(store.state.maxVarieties) && store.state.maxVarieties.filter(item => {
    return item.code === code
  })
  return res[0].name
}
